export default __webpack_public_path__ + "static/media/video is not available.7cebe097.png";